{
  "assets": {
    "upload_new": "Carregar novo {{ assetType }}"
  },
  "edit_layer": {
    "discard_title": "Alterações não salvas",
    "discard_message": "Ao clicar em sim, você concorda em descartar todas as alterações não salvas feitas nessa camada. Você ainda deseja continuar?"
  },
  "move": {
    "moveTo": "Mover para este local",
    "setTo": "Definir nova localização",
    "tooltip": {
      "Map": "Não é possível entrar em um plano",
      "Layer": "Não é possível entrar em uma camada"
    },
    "tooltip_self": "Não é possível mover uma pasta para dentro dela"
  },
  "fixed_shape": {
    "length": "Comprimento",
    "width": "Largura"
  },
  "mapObjectSidebarOptions": {
    "hide_object": "Ocultar objeto",
    "show_object": "Mostrar objeto",
    "hide_group": "Ocultar grupo",
    "show_group": "Mostrar grupo"
  },
  "object_details": {
    "minimise": "Minimize os detalhes do objeto",
    "edit_attributes": "Gerenciar atributos",
    "object_details": "DETALHES DO OBJETO",
    "object_name": "Nome do objeto"
  },
  "verticalBarErrors": {
    "layer_hidden_drawing": "Você não pode editar uma camada que está oculta",
    "layer_locked_drawing": "Você não pode editar uma camada que está bloqueada",
    "hide_layer_composition": "Você não pode ocultar uma camada enquanto a está editando",
    "group_composition": "Você não pode ocultar um grupo enquanto estiver editando uma de suas camadas"
  },
  "export_map": {
    "export_map": "Plano de exportação",
    "export_preview": "Pré-visualização de exportação",
    "lock_map": "Bloquear janela de visualização",
    "orientation": {
      "title": "Orientação da página",
      "portrait": "Retrato",
      "landscape": "Paisagem"
    },
    "page_size": {
      "title": "Tamanho da página"
    },
    "file_format": {
      "title": "Formato de arquivo"
    },
    "scale": "Escala",
    "infoTooltip": {
      "title": "Janela de visualização",
      "text": "Clique no mapa para rolar e ajustar sua janela de visualização e, em seguida, bloqueie a janela de visualização para salvar as alterações em seu editor."
    },
    "positionMapOverlay": {
      "title": "Posicione o mapa",
      "text": "Deslocar, ampliar e girar para escolher a área a ser exportada"
    },
    "read_user_visibility_warning": "As exportações excluem mudanças de visibilidade de usuários sem permissão de acesso total no mapa."
  },
  "styles": {
    "customiseColour": "Personalize a cor",
    "scaleText": "Ícone de escala para caber no texto",
    "textMargin": "Margem de texto",
    "modelVariableSizeError": "Valor inválido. Certifique-se de que todos os valores estejam entre {{ minValue }} e {{ maxValue }}",
    "dimensions": "Dimensões",
    "customDimensions": "Personalize as dimensões dos modelos",
    "customColour": "Permitir cores personalizadas.",
    "customImage": "Permitir imagem personalizada (proporção opcional).",
    "widthLengthHeight": "Largura, comprimento, altura"
  },
  "permissions": {
    "permission_is": "A permissão é",
    "readonly": "somente leitura",
    "map": "no plano",
    "layer": "uma camada",
    "selection": "na seleção"
  },
  "layer_overflow": {
    "hidden_text": "Menu de estouro de camadas",
    "layer_properties": "Configurações de camada",
    "attribute_table": "Tabela de atributos",
    "delete_layer": "Excluir camada",
    "layer_view": {
      "display_text": "Visualização em camadas",
      "view_by_object": "Exibir por objeto",
      "view_by_attribute": "Exibir por atributo"
    },
    "remove_from_map": "Remover do plano",
    "manage_permissions": "Gerenciar permissões"
  },
  "plan": "Planos",
  "dashboard": "Painel de controle",
  "units": {
    "feet": "Pés"
  },
  "controls": {
    "set_pitch": "Incline a vista"
  },
  "toolbarButtonTooltips": {
    "helpButton": "Socorro",
    "layers": "Voltar às camadas"
  }
}